import ApiClient from './ApiClient';
import { BONJIRI_TOKEN_KEY } from './ApiClient';

const client = new ApiClient();

export default {
  initPassword: (email, signupToken) => {
    return new Promise((resolve, reject) => {
      client
        .post(
          'me/password/init/email',
          {
            email: email
          },
          {
            headers: { [BONJIRI_TOKEN_KEY]: signupToken }
          }
        )
        .then(data => {
          resolve(data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  confirmPasswordChange: (password, passwordInitCode) => {
    return new Promise((resolve, reject) => {
      client
        .post('me/password/init/confirm', {
          passwordInitCode: passwordInitCode,
          password: password
        })
        .then(data => {
          resolve(data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchDataAtOnce: () => {
    return Promise.all([client.get('me?scope[]=check_list'), client.get('me/works?scope[]=status_changed_logs&scope[]=work_check_lists&scope[]=work_check_list_info')])
      .then(values => {
        const data = values[0].data;
        data.me.works = values[1].data.works;
        return Promise.resolve(data);
      })
      .catch(error => {
        return Promise.reject(error);
      });
  },
  fetchSubmissions: workId => {
    return new Promise((resolve, reject) => {
      client
        .get(`me/works/${workId}/submissions?scope[]=submission_files`)
        .then(data => {
          resolve(data.data.submissions);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  uploadFile: file => {
    let formData = new FormData();
    formData.append('file', file);
    return new Promise((resolve, reject) => {
      client
        .post(`me/tmp_files`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(data => {
          resolve(data.data.uuid);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  /**
   * POST submissions WITH FILES.
   * @param Form formData generated by FormData()
   */
  postSubmissions: (
    workId,
    { userComment, submissionType, submissionFiles }
  ) => {
    return client.post(
      `me/works/${workId}/submissions`,
      {
        userComment,
        submissionType,
        submissionFiles
      },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
  },
  patchUserComment: (submissionId, comment) => {
    return client.patch(`me/submissions/${submissionId}`, {
      userComment: comment
    });
  },
  addFilesToSubmission: (submissionId, files) => {
    return client.post(`me/submissions/${submissionId}/submission_files`, {
      submissionFiles: files
    });
  },
  fetchAwards: (awardId, scope = null) => {
    return new Promise((resolve, reject) => {
      let url = `me/awards/${awardId}`;
      if (scope) {
        url = url + `?scope[]=${scope}`;
      }
      client
        .get(url)
        .then(data => {
          resolve(data.data.award);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchAttachedAnswers: workId => {
    return new Promise((resolve, reject) => {
      client
        .get(`me/works/${workId}/attached_answers`)
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  postAttachedAnswers: (workId, form) => {
    return client.post(`me/works/${workId}/attached_answers`, form);
  },
  patchAttachedAnswers: (workId, form) => {
    return client.patch(`me/works/${workId}/attached_answers/bulk`, form);
  },
  fetchMe: () => {
    return new Promise((resolve, reject) => {
      client
        .get(`me`)
        .then(data => {
          resolve(data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchWork: workId => {
    return new Promise((resolve, reject) => {
      client
        .get(`me/works/${workId}`)
        .then(data => {
          resolve(data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchEmum: type => {
    return new Promise((resolve, reject) => {
      client
        .get(`me/enums?enum_type=${type}`)
        .then(data => {
          resolve(data.data.enums);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchAllEmum: () => {
    return new Promise((resolve, reject) => {
      client
        .get(`me/enums`)
        .then(data => {
          resolve(data.data.enums);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  changePassword: password => {
    return new Promise((resolve, reject) => {
      client
        .post(`me/password/change`, {
          password: password
        })
        .then(data => {
          resolve(data.result);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchApplicantCheckLists: () => {
    return client.get(`/me/applicant_check_lists`);
  },
  postApplicantCheckLists: (applicantCheckLists) => {
    return client.post(`/me/applicant_check_lists`, {
      applicantCheckLists
    });
  },
  postWorkCheckLists: (workCheckListAnswers) => {
    return client.post(`me/work_check_list_answers`, {
      workCheckListAnswers
    });
  }
};
